import { render, staticRenderFns } from "./molecule.trayNavigationMenu.editImageGallery.vue?vue&type=template&id=bd5f6956"
import script from "./molecule.trayNavigationMenu.editImageGallery.vue?vue&type=script&lang=ts"
export * from "./molecule.trayNavigationMenu.editImageGallery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports